export class StoreApiError extends Error {
  constructor(public readonly code: string, message: string, public readonly status: number, public readonly details?: unknown) { super(message); }
}

export async function apiJson<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, init);
  const payload: unknown = await response.json().catch(() => null);
  if (!response.ok) {
    const body = payload as { error?: { code?: string; message?: string; details?: unknown } } | null;
    throw new StoreApiError(body?.error?.code ?? 'request_failed', body?.error?.message ?? '요청을 처리하지 못했습니다.', response.status, body?.error?.details);
  }
  return payload as T;
}

export async function sha256Payload(value: unknown): Promise<string> {
  const bytes = new TextEncoder().encode(JSON.stringify(value));
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return `sha256:${[...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('')}`;
}

type TossPaymentRequest = {
  method: 'CARD';
  amount: { currency: 'KRW'; value: number };
  orderId: string;
  orderName: string;
  successUrl: string;
  failUrl: string;
  customerName: string;
  customerEmail?: string;
};

declare global {
  interface Window {
    TossPayments?: (clientKey: string) => { payment(input: { customerKey: string }): { requestPayment(input: TossPaymentRequest): Promise<void> } };
  }
}

let tossLoader: Promise<void> | undefined;
export function loadTossPayments(): Promise<void> {
  if (window.TossPayments) return Promise.resolve();
  if (tossLoader) return tossLoader;
  tossLoader = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://js.tosspayments.com/v2/standard';
    script.async = true;
    script.addEventListener('load', () => window.TossPayments ? resolve() : reject(new Error('결제 SDK를 확인하지 못했습니다.')));
    script.addEventListener('error', () => reject(new Error('결제 SDK를 불러오지 못했습니다.')));
    document.head.appendChild(script);
  });
  return tossLoader;
}
